import { memo, useState, type FC } from 'react';
import { StyleSheet } from 'react-native';
import { TouchableRipple } from 'react-native-paper';

import { AddCircleIcon } from '@/assets';
import { GroupsRoute } from '@/features/groups/navigation/groupsRoute';
import { useVerification } from '@/features/verification/providers/useVerification';
import { useAppNavigation } from '@/navigation/hooks/useAppNavigation';
import { useAppTheme } from '@/styles/hooks/useAppTheme';
import type { AppTheme } from '@/styles/theme';

const makeStyles = (theme: AppTheme) =>
  StyleSheet.create({
    add: {
      width: 40,
      height: 40,
      borderRadius: 20,
      alignItems: 'center',
      justifyContent: 'center'
    },
    addHover: { backgroundColor: theme.stateLayers.hover }
  });

export const MeinOrtGroupCreateButton: FC = memo(() => {
  const theme = useAppTheme();
  const styles = makeStyles(theme);
  const navigation = useAppNavigation();
  const { ensureVerified, isVerified } = useVerification();
  const [hover, setHover] = useState(false);

  const onPress = () => {
    if (isVerified) {
      navigation.navigate(GroupsRoute.GroupEditor);
    } else {
      ensureVerified();
    }
  };

  return (
    <TouchableRipple
      onPress={onPress}
      onHoverIn={() => setHover(true)}
      onHoverOut={() => setHover(false)}
      rippleColor={theme.rippleColors.onSurface}
      borderless
      style={[styles.add, hover && styles.addHover]}
    >
      <AddCircleIcon width={28} height={28} fill={theme.colors.primary} />
    </TouchableRipple>
  );
});
MeinOrtGroupCreateButton.displayName = 'MeinOrtGroupCreateButton';
